import React from 'react';

class HomeSectionThree extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let btnBgImgSection = document.querySelector('.ll__home--intro');
    let btnBgImgs = document.querySelectorAll('.btn__bgImg');
    let thisBgImg;
    Array.from(btnBgImgs).forEach(function (btnBgImg) {
      btnBgImg.addEventListener('mouseenter', function () {
        thisBgImg = this.getAttribute('data-bgImg');
        btnBgImgSection.classList.add('showing-bgimg');
        document.getElementById(thisBgImg).classList.add('is-showing');
      });
      btnBgImg.addEventListener('mouseleave', function () {
        btnBgImgSection.classList.remove('showing-bgimg');
        document.getElementById(thisBgImg).classList.remove('is-showing');
      });
    });
  }

  render() {
    let page_id = this.props.page_id;
    let handleClickTop = this.props.handleClickTop;
    let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.section_three : [];
    let heading = sectionData.heading;
    let blocks = sectionData.content_block && sectionData.content_block.length ? sectionData.content_block : [];

    let blockHtml = blocks.map((item, key) => {
      let url = item.url && item.url != '' ? item.url : 'javascript:void(0)';
        return (
            <div className="grid-item" key={key}>
                <article key={key}>
                    <h6 className="title-sm mt-0"><a href={url}>{item.headding}</a></h6>
                    <div className="desc" dangerouslySetInnerHTML={{__html:item.content}} />
                </article>
                <figure><a href={url}><img src={item.image.url} alt={item.image.alt} title={item.image.title} /></a></figure>
            </div>
        )
    })

    return (
        <section className="section">
            <div className="main-container">
                <div className="ll__home--intro-grid">
                    <h2 className="title-lg w-100 sec-title">{heading}</h2>
                    <div className="grid-3 m-0">
                        {blockHtml}
                    </div>
                    <a href="javascript:" className="btn-arw-top backToTop mt-35" onClick={handleClickTop}>Back to top</a>
                </div>
            </div>
        </section>
    );
  }
}

export default HomeSectionThree;


// WEBPACK FOOTER //
// ./src/components/Home/HomeSectionThree.js